<template>
    <div class="lc_container" :style="{'width' : width}">

        <slot name="body" />


        <div class="topRight">
            <slot name="topRight" />
        </div>

        <div class="topLeft" :class="p_class_s">
            <slot name="topLeft" />
        </div>

        <div class="middleRight">
            <slot name="middleRight" />
        </div>

        <div class="middleLeft">
            <slot name="middleLeft" />
        </div>

        <div class="middle">
            <slot name="middle" />
        </div>


        <div class="bottom">
            <slot name="bottom" />
        </div>

        <div class="bottomRight">
            <slot name="bottomRight" />
        </div>
        <div class="bottomLeft">
            <slot name="bottomLeft" />
        </div>



    </div>
</template>

<script>
    export default {
        name: "TqOnTopContainer",
        props:{
            width: {
                type: String,
                default: "100%"
            },
            p_class_s:{
                type: String,
            }
        }
    }
</script>

<style scoped lang="scss">
    .lc_container {
        position: relative;
        /*text-align: center;*/
        /*display: inline-block;*/
        /*width: auto; // for edit quest explore gallery*/
        /*width: 100%;*/
        /*width: inherit;*/
        display: grid;
    }

    .topRight{
        position: absolute;
        right: 0;
        top: 0;
    }

    .topLeft{
        position: absolute;
        left: 0;
        top: 0;
    }

    .middleRight{
        position: absolute;
        right: 4px;
        top: 50%;
        transform: translate(0, -50%);
        /*height: 100%;*/
    }
    .middleLeft{
        position: absolute;
        left: 4px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .middle{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        display: inline-grid;
    }

    .bottom{
        position: absolute;
        bottom: 0;
        width: inherit;
    }

    .bottomRight{
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .bottomLeft{
        position: absolute;
        bottom: 0;
        left: 0;
    }

</style>